export default function Formats() {
  const formats = [
    { icon: 'ri-building-2-line', title: 'Корпоративный тренинг', desc: '1-2 дня интенсивной практики для отдела продаж компании. Полный разбор с записью звонков.' },
    { icon: 'ri-phone-line', title: 'Практикум по звонкам', desc: 'Интенсивный формат с живыми звонками и разбором в реальном времени. Максимум практики.' },
    { icon: 'ri-flashlight-line', title: 'Интенсив', desc: 'Сжатый формат для быстрой прокачки ключевых навыков за 1 день.' },
    { icon: 'ri-computer-line', title: 'Онлайн', desc: 'Живые онлайн-сессии с отработкой звонков через видеосвязь. Полный функционал без потери качества.' },
    { icon: 'ri-stack-line', title: 'Серия модулей', desc: '2-4 модуля с домашними заданиями между ними. Максимальное закрепление навыков.' },
    { icon: 'ri-user-follow-line', title: 'Сопровождение отдела', desc: 'Долгосрочная программа: аудит, обучение, полевой контроль, корректировка. От 3 до 6 месяцев.' },
    { icon: 'ri-user-star-line', title: 'Индивидуальный коучинг', desc: 'Персональная работа с руководителем или ключевым менеджером. Разбор звонков и стратегии.' },
  ];

  return (
    <section id="formats" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Форматы обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            От однодневного интенсива до многомесячной программы сопровождения — выберите формат под ваши задачи.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {formats.slice(0, 4).map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 hover:shadow-md transition-shadow group">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="grid sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {formats.slice(4).map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 hover:shadow-md transition-shadow group">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}